import { render, staticRenderFns } from "./PosApp.vue?vue&type=template&id=6f9ed885&scoped=true"
import script from "./PosApp.vue?vue&type=script&lang=js"
export * from "./PosApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ed885",
  null
  
)

export default component.exports